export enum ConsolidatedAttachmentUploadStatus {
    SYNC_IN_PROGRESS = "SYNC_IN_PROGRESS",
    SYNC_COMPLETED = "SYNC_COMPLETED"
}